import * as React from 'react';

const BugIcon = (props) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-hidden="true"
    {...props}
  >
    <path
      d="M14.3038 8.75H11.1523"
      stroke="#CF222E"
      strokeWidth={1.25}
      strokeLinecap="round"
    />
    <path
      d="M4.85067 8.75H1.69922"
      stroke="#CF222E"
      strokeWidth={1.25}
      strokeLinecap="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.1534 7.17434V10.3252C11.1534 10.5038 11.138 10.6823 11.1063 10.8504C10.8593 12.3421 9.56258 13.4761 8.00246 13.4761C6.44234 13.4761 5.14562 12.3421 4.89866 10.8504C4.86744 10.6823 4.85156 10.5038 4.85156 10.3252V7.17434C4.85156 6.99582 4.86744 6.8173 4.89866 6.64919C5.14562 5.15752 6.44234 4.02344 8.00246 4.02344C8.87424 4.02344 9.66169 4.375 10.2296 4.94779C10.6857 5.39901 11.0017 5.98768 11.1063 6.64919C11.138 6.8173 11.1534 6.99582 11.1534 7.17434Z"
      stroke="#CF222E"
      strokeWidth={1.25}
      strokeLinecap="round"
    />
    <path
      d="M2.22266 3.49609V3.94075C2.22266 4.64441 2.49865 5.32015 2.99094 5.82285L3.00737 5.83983C3.51281 6.35622 4.20552 6.64699 4.92836 6.64699H11.0867C11.8002 6.64699 12.4842 6.36388 12.989 5.85899C13.4934 5.3552 13.777 4.6707 13.777 3.95772V3.49609"
      stroke="#CF222E"
      strokeWidth={1.25}
      strokeLinecap="round"
    />
    <path
      d="M11.1055 10.8477H11.1203C11.8135 10.8477 12.4783 11.1226 12.9684 11.6127L13.0128 11.6576C13.5034 12.1477 13.7789 12.8125 13.7789 13.5057V13.9986"
      stroke="#CF222E"
      strokeWidth={1.25}
      strokeLinecap="round"
    />
    <path
      d="M2.22656 13.9986V13.5221C2.22656 12.8376 2.49489 12.1811 2.97349 11.6926L3.03427 11.6313C3.52547 11.1302 4.19793 10.8477 4.89995 10.8477"
      stroke="#CF222E"
      strokeWidth={1.25}
      strokeLinecap="round"
    />
    <path
      d="M8 6.64844V13.4754"
      stroke="#CF222E"
      strokeWidth={1.25}
      strokeLinecap="round"
    />
    <path
      d="M10.1015 4.82852V3.49456C10.1015 2.81571 9.67225 2.23718 9.07031 2.01562"
      stroke="#CF222E"
      strokeWidth={1.25}
      strokeLinecap="round"
    />
    <path
      d="M5.90234 4.83083V3.49687C5.90234 2.79882 6.35626 2.20685 6.98505 2"
      stroke="#CF222E"
      strokeWidth={1.25}
      strokeLinecap="round"
    />
  </svg>
);

export default BugIcon;
